import { HttpClient } from '@angular/common/http';
import { Data, Response, UPSERT, waitAndRetry } from '@dimandzhi/graphql';
import { currentMethodName } from 'app/current-method-name';
import { GraphQL } from 'app/graphql';
import { environment as env } from 'environments/environment';
import _ from 'lodash';
import { BehaviorSubject, Observable } from 'rxjs';
import { first, map } from 'rxjs/operators';
import { UpsertResp } from './_utils';

type gqlType = GraphQL.ChannelASRPriotiyOffset;
const gqlType = GraphQL.ChannelASRPriotiyOffset;
const ModelName = gqlType.getModelName();
export class ChannelASRPriotiyOffset {
  // capo - channel asr priotiy offset
  private caposFirstCall: boolean;
  private capos = new BehaviorSubject<gqlType[]>([]);

  constructor(
    protected http: HttpClient
  ) { }

  initChannelASRPriotiyOffsets() {
    this.caposFirstCall = true;
    this.capos = new BehaviorSubject<gqlType[]>([]);
  }

  setChannelASRPriotiyOffset(capo: gqlType) {
    let action: UPSERT = 'update';
    if (capo.id === undefined) {
      action = 'insert';
    }
    return this.http.post<Response>(`${env.graphql}/${currentMethodName()}`, `
        mutation {
          ${action} {
            ${ModelName}(values:[{${capo.mutationData()}}])
          }
        }`
    ).pipe(
      first(),
      Data.fromResp,
      UpsertResp(action, ModelName),
    );
  }

  insertChannelASRPriotiyOffset(capo: gqlType) {
    return this.setChannelASRPriotiyOffset(capo).pipe(
      map(IDs => {
        if (!_.isArrayLike(IDs)) {
          throw new Error(`IDs is not an array: ${typeof IDs} ${IDs}`);
        }
        const id = _.head(IDs);
        if (!_.isNumber(id)) {
          throw new Error(`id is not a number: ${typeof id} ${id}`);
        }
        capo.id = id;
        this.capos.next(this.capos.value.concat(capo));
        return id;
      })
    );
  }

  updateChannelASRPriotiyOffset(capo: gqlType) {
    return this.setChannelASRPriotiyOffset(capo).pipe(
      map(rowsAffected => {
        if (!_.isNumber(rowsAffected)) {
          throw new Error(`rowsAffected is not a number: ${typeof rowsAffected} ${rowsAffected}`);
        }
        if (rowsAffected > 0) {
          //this.channels.next(this.channels.value.concat(channel));
        }
        return rowsAffected;
      })
    );
  }

  deleteChannelASRPriotiyOffset(capo: gqlType) {
    return this.http.post<Response>(`${env.graphql}/${currentMethodName()}`, `
        mutation {
          delete {
            ${ModelName}(values:[${capo.id}])
          }
        }`
    ).pipe(
      first(),
      Data.fromResp,
      map(data => {
        const rowsAffected = data.deleteResp(ModelName);
        if (!_.isNumber(rowsAffected)) {
          throw new Error(`rowsAffected is undefined: ${typeof rowsAffected} ${rowsAffected}`);
        }
        this.capos.next(this.capos.value.filter(s => s.id !== capo.id));
        return rowsAffected;
      })
    );
  }

  getChannelASRPriotiyOffsets(): Observable<gqlType[]>;
  getChannelASRPriotiyOffsets(asSnapshot: boolean): gqlType[];
  getChannelASRPriotiyOffsets(asSnapshot?: boolean) {
    if (this.caposFirstCall) {
      this.refreshChannelASRPriotiyOffsets();
      this.caposFirstCall = false;
    }
    if (asSnapshot) {
      return this.capos.getValue();
    }
    return this.capos.asObservable();
  }

  private refreshChannelASRPriotiyOffsets() {
    this.http.post<Response>(`${env.graphql}/${currentMethodName()}`, `
        query {
          ${ModelName} {
            get {
              data {
                ${gqlType.fields({ withSubFields: true })}
              }
            }
          }
        }`
    ).pipe(waitAndRetry, Data.fromResp).subscribe({
      next: data => this.capos.next(gqlType.fromData(data)),
      error: err => this.capos.error(err)
    });
  }
}